<template>
  <div>
    <wc-data-box
      title='Staff to follow up'
      :titleIcon='$store.state.icons.modules.profile.icon'
      :titleIconColor='$store.state.icons.modules.profile.color'
      showEdit
      @edit='edit'
    >
      <wc-two-column-table :items='tableData'></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      title='Staff to follow up'
      :icon='$store.state.icons.modules.profile.icon'
      width='400'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-form v-model='isFormValid'>
        <v-card-text>
          <v-autocomplete
            dense
            label='Assign to'
            :items='profiles'
            item-text='name_display'
            item-value='id'
            v-model='inquiryCopy.assigned_to'
          ></v-autocomplete>
          <v-select
            :items='$store.state.misc.globalOptions.inquiryStatuses'
            v-model='inquiryCopy.status'
            label='Status'
            dense
          ></v-select>
        </v-card-text>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import staffingAPI from '@/modules/staffing/api/staffing'

export default {
  name: 'inquiry-assigned-to',
  data: () => ({
    showDialog: false,
    isFormValid: false,
    isLoading: false,
    saving: false,
    profiles: [],
    inquiryCopy: {}
  }),
  props: {
    inquiry: {
      required: true
    }
  },
  mounted () {
    this.getData()
  },
  computed: {
    tableData () {
      let data = []
      if (this.inquiry) {
        data = [
          { text: 'Assigned To', value: this.inquiry.assigned_to ? this.inquiry.assigned_to_obj.name_display : "not set..."},
          { text: 'Status', value: this.inquiry.status }
        ]
      }
      return data
    }
  },
  methods: {
    edit () {
      this.inquiryCopy = _.cloneDeep(this.inquiry)
      this.showDialog = true
    },
    save () {
      this.$emit('update', this.inquiryCopy)
      this.showDialog = false
    },
    async getData () {
      this.isLoading = true
      let profiles = await staffingAPI.getProfiles()
      let filtered = _.filter(profiles, 'is_active')
      let fp = _.filter(filtered, p => p.name_display != 'Matt Jullion' && p.name_display != 'Elijah MacLeod-Shaw' && p.name_display != 'POSTMARK')
      this.profiles = _.orderBy(fp, 'perms.length', 'desc')
      this.isLoading = false
    },
  }
}
</script>